import React from 'react'

const NavBar = () => {
  return (
    <div className='navbar'>
        <a href='/'>SINEM BANNA</a></div>
  )
}

export default NavBar